import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { GrupoClassificacaoClassificavelFormModule } from '../../../../grupo-classificacao/classificavel/form';

import { LeadClassificacaoFormComponent } from './lead-classificacao-form.component';

@NgModule({
    imports: [
        SharedModule,
        GrupoClassificacaoClassificavelFormModule
    ],
    declarations: [
        LeadClassificacaoFormComponent
    ],
    exports: [
        LeadClassificacaoFormComponent
    ]
})
export class LeadClassificacaoFormModule { }
